"use strict";

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";
import {
     factTableListComplete,
     ajaxError,
     factTableTypesComplete,
     factTableAddComplete,
     factTableDeleteComplete,
     factTableGetComplete,
     factTableUpdateComplete,
     factTableActiveInactiveComplete,
     factTableListRequest,
     factTableValueAddComplete,
     factTableValueDeleteComplete,
     factTableSchemaValueGetComplete,
     factTableValueUpdateComplete,
     factTableValueListComplete,
     factTableValueListRequest,
     factTableLabelsComplete,
     factTableGetAllSchemeAttributeComplete,
     factTableGetAllSchemaTypeComplete,
     factTableSchemaValueReOrderComplete,
     factTableGetValueComplete,
     factTableSchemaTemplateComplete,
     factTableCSVFileUploadComplete,
     factTableCreateByCsvUploadComplete,
     factTableGetJsonSchemaComplete,
     factTableAddTableRecordComplete,
     factTableDeleteTableRecordComplete,
     factTableEditTableRecordComplete,
     factTableGetTableRecordComplete,
} from "../_actions";
import { authConstants, requestTypes, factTableConstants } from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";

export const factTableAddEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_ADD_REQUEST),
          mergeMap((action) => {
               const { navigate, ...payload } = action.payload;

               if (!payload.active) {
                    payload.active = false;
               }
               return ajax
                    .post(
                         "/api/factTable/add",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              navigate("/app/fact-data-manage");
                              return factTableAddComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTableListEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_LIST_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/factTable/search",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) =>
                              factTableListComplete(ajaxResponse.response),
                         ),
                         catchError((error) => {
                              return of(ajaxError(error));
                         }),
                    );
          }),
     );
};

export const factTableSearchEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_SEARCH_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/factTable/search",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) =>
                              factTableListComplete(ajaxResponse.response),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTableTypesEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_TYPES_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/factTable/types",

                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return factTableTypesComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTableDeleteEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_DELETE_REQUEST),
          mergeMap((action) => {
               const { page, pageSize, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/factTable/delete",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   factTableDeleteComplete(
                                        ajaxResponse.response,
                                   ),
                                   factTableListRequest({
                                        page: page,
                                        pageSize: pageSize,
                                   }),
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTableGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_GET_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/factTable/get",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return factTableGetComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTableEditEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_UPDATE_REQUEST),
          mergeMap((action) => {
               const { navigate, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/factTable/edit",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              navigate("/app/fact-data-manage");
                              return factTableUpdateComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTableActiveInactiveEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_ACTIVE_INACTIVE_REQUEST),
          mergeMap((action) => {
               const { page, pageSize, ...payload } = action.payload;
               /// here i need to dispatch ajaxError action
               return ajax
                    .post(
                         "/api/factTable/activeInactive",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   factTableActiveInactiveComplete(
                                        ajaxResponse.response,
                                   ),
                                   factTableListRequest({
                                        page: page,
                                        pageSize: pageSize,
                                   }),
                              ),
                         ),

                         catchError((error) => {
                              return of(
                                   factTableListRequest({
                                        page: page,
                                        pageSize: pageSize,
                                   }),
                                   ajaxError(error),
                              );
                         }),
                    );
          }),
     );
};

export const factTableValueAddEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_VALUE_ADD_REQUEST),

          mergeMap((action) => {
               const { closeFormModal, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/factTable/tableValueAdd",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              closeFormModal();
                              return of(
                                   factTableValueAddComplete(
                                        ajaxResponse.response,
                                   ),
                                   factTableValueListRequest({
                                        page: 1,
                                        pageSize: 100,
                                        factTableId: action.payload.factTableId,
                                        search: "",
                                   }),
                              );
                         }),
                         catchError((error) => {
                              return of(ajaxError(error));
                         }),
                    );
          }),
     );
};

export const factTableValueListEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_SCHEMA_VALUE_LIST_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/factTable/getAllFactTableSchema",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) =>
                              factTableValueListComplete(ajaxResponse.response),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTableValueDeleteEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_SCHEMA_VALUE_DELETE_REQUEST),
          mergeMap((action) => {
               const { factTableId, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/factTable/deleteFactTableSchema",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) =>
                              of(
                                   factTableValueDeleteComplete(
                                        ajaxResponse.response,
                                   ),
                                   factTableValueListRequest({
                                        page: 1,
                                        pageSize: 100,
                                        factTableId,
                                        search: "",
                                   }),
                              ),
                         ),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTableSchemaValueGetEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_SCHEMA_VALUE_GET_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/factTable/getFactTableSchema",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return factTableSchemaValueGetComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTableValueEditEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_VALUE_UPDATE_REQUEST),
          mergeMap((action) => {
               const { closeFormModal, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/factTable/updateFactTableSchema",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              closeFormModal();
                              return of(
                                   factTableValueUpdateComplete(
                                        ajaxResponse.response,
                                   ),
                                   factTableValueListRequest({
                                        page: 1,
                                        pageSize: 100,
                                        factTableId: action.payload.factTableId,
                                        search: "",
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTableGetAllSchemaTypeEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_GET_ALL_SCHEMA_TYPE_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/factTable/getAllFactTableSchemaType",

                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return factTableGetAllSchemaTypeComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTableGetAllSchemeAttributeEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               factTableConstants.FACT_TABLE_GET_ALL_SCHEMA_ATTRIBUTE_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/factTable/getAllFactTableSchemaAttribute",
                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return factTableGetAllSchemeAttributeComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTablesSchemaValueReOrderEditEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_SCHEMA_VALUE_REORDER_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/factTable/reorderFactTableSchema",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              return of(
                                   factTableSchemaValueReOrderComplete(
                                        ajaxResponse.response,
                                   ),
                                   factTableValueListRequest({
                                        page: 1,
                                        pageSize: 100,
                                        factTableId: action.payload.factTableId,
                                        search: "",
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTablesGetValueEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_GET_VALUE_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/factTable/getValues",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return factTableGetValueComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTablesSchemaTemplateEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_SCHEMA_TEMPLATE_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/factTable/schemaTemplate",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return factTableSchemaTemplateComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTablesCreateByCsvUploadEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_CREATE_BY_CSV_REQUEST),
          mergeMap((action) => {
               const { setDefault, form, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/factTable/createByCsvUpload",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              setDefault();
                              form.reset();
                              return factTableCreateByCsvUploadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         concatMap((ajaxResponse) => {
                              return of(
                                   factTableCreateByCsvUploadComplete(
                                        ajaxResponse.response,
                                   ),
                                   factTableListRequest({
                                        page: 0,
                                        pageSize: 5,
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTablesGetJsonSchemaEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.GET_FACT_TABLE_JSON_SCHEMA_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/factTable/getJsonSchema",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return factTableGetJsonSchemaComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTablesFactTableRecordEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.ADD_FACT_TABLE_SCHEMA_RECORD_REQUEST),
          mergeMap((action) => {
               const { getManageDataList, closeModal, ...payload } =
                    action.payload;

               return ajax
                    .post(
                         "/api/factTable/factTableRecord",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return factTableAddTableRecordComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         concatMap((ajaxResponse) => {
                              closeModal();
                              getManageDataList();
                              return of(
                                   factTableAddTableRecordComplete(
                                        ajaxResponse.response,
                                   ),
                                   getValues({
                                        page: 1,
                                        pageSize: 5,
                                        factTableId: action.payload.factTableId,
                                        search: "",
                                   }),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTablesDeleteJsonSchemaEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.DELETE_FACT_TABLE_SCHEMA_RECORD_REQUEST),
          mergeMap((action) => {
               const { getManageDataList, ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/factTable/deleteJsonSchema",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              getManageDataList();
                              return of(
                                   factTableDeleteTableRecordComplete(
                                        ajaxResponse.response,
                                   ),
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTablesGetTableRecordEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.GET_FACT_TABLE_SCHEMA_RECORD_REQUEST),
          mergeMap((action) => {
               const { ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/factTable/getFactTableRecord",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return factTableGetTableRecordComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factTablesEditTableRecordEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.EDIT_FACT_TABLE_SCHEMA_RECORD_REQUEST),
          mergeMap((action) => {
               const { getManageDataList, closeModal, ...payload } =
                    action.payload;

               return ajax
                    .post(
                         "/api/factTable/updateFactTableRecord",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              getManageDataList();
                              closeModal();
                              return factTableEditTableRecordComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const factLabelsTypesEpic = (actions$) => {
     return actions$.pipe(
          ofType(factTableConstants.FACT_TABLE_LABELS_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/factTable/labels",

                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return factTableLabelsComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};